<template>
  <div>
    <Toolbar :title="`Zertifikat ${questionnaire.title}`" />
    <div class="md-layout md-alignment-top-center">
      <md-content
        id="certificate"
        class="md-layout-item md-elevation-10 md-xlarge-size-33 md-large-size-50 md-medium-size-66 md-small-size-90 md-xsmall-size-90"
      >
        <div id="logo" class="md-layout md-alignment-center-center">
          <div
            class="md-layout-item md-xlarge-size-33 md-large-size-33 md-medium-size-33 md-small-size-66 md-xsmall-size-66"
          >
            <img src="../assets/dslv_logo.svg" />
          </div>
        </div>
        <div id="text" class="md-layout md-alignment-top-center">
          <div
            class="md-layout-item md-xlarge-size-66 md-large-size-66 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
          >
            <h1>{{ name }}</h1>
            <p class="md-caption">({{ email }})</p>
            <p>
              <strong>geboren am {{ formatDate(birthday) }}</strong>
            </p>

            <p class="md-body-1">
              hat an der ONLINETheorieprüfung
              <strong>{{ questionnaire.title }}</strong>
              am {{ formatDate(dt) }} erfolgreich teilgenommen.
            </p>
            <p>
              Dieser Nachweis berechtigt zur Zulassung zur Prüfung
              {{ questionnaire.title }} in der aktuellen Saison.
            </p>
          </div>
        </div>
        <div class="md-layout md-alignment-top-center">
          <div
            id="signature"
            class="md-layout-item md-xlarge-size-66 md-large-size-66 md-medium-size-70 md-small-size-80 md-xsmall-size-100"
          >
            <p>
              Grainau, <em>{{ formatDate(dt) }}</em>
            </p>
            <div class="md-layout md-gutter">
              <div class="md-layout-item">
                <img src="../assets/holzmann.png" />
                <p class="md-caption">Max Holzmann, Vorstand Ausbildung</p>
              </div>
              <div class="md-layout-item"></div>
            </div>
          </div>
        </div>
      </md-content>
    </div>
  </div>
</template>

<script>
export const NOTIFICATION_LOADING =
  "Wir versuchen dir das Zertifikat zusätzlich per Mail zu senden...";
export const NOTIFICATION_SUCCESS =
  "Das Zertifikat wurde erfolgreich per Mail versandt.";
export const NOTIFICATION_FAILURE =
  "Leider konnte das Zertifkat nicht per Mail zugestellt werden. Tipp: Erstelle zur Sicherheit einen Screenshot von deinem Zertifikat ;)";

import Toolbar from "./Toolbar.vue";
import { formatDate } from "../certificate";

export default {
  props: {
    identifier: {
      type: String,
      required: true,
    },
  },
  components: {
    Toolbar,
  },
  async mounted() {
    const certificate = this.$store.state[this.identifier].certificate;

    if (!certificate) {
      this.$router.push(`/${this.identifier}`);
      return;
    }

    this.questionnaire = this.$store.state.questionnaires[this.identifier];
    this.name = certificate.name;
    this.birthday = certificate.birthday;
    this.email = certificate.email;
    this.dt = certificate.dt;
  },
  data: () => ({
    formatDate,
    questionnaire: {
      title: "",
    },
    name: "",
    birthday: "",
    email: "",
    dt: "",
  }),
};
</script>

<style scoped>
#certificate {
  width: 100%;
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #c0c0c0;
  font-family: Arial, sans-serif;
  margin: 4% 1% 1% 1%;
  padding: 20px;
  text-align: center;
}

#certificate #text {
  margin: 4rem 0;
}

#certificate #logo {
  margin: 0;
}
#signature {
  text-align: left;
}
</style>
